module.exports = __webpack_public_path__ + "static/media/otp-phone.c9d5a46b.png";